import React from 'react';

/**
 * Recent earnings list component
 * @param {Object} props
 * @param {Array} props.earnings - List of earning objects
 * @param {Object} props.translations - Translation strings
 * @param {string} props.railsEnv - Rails environment (for test IDs)
 */
const RecentEarnings = ({ earnings, translations, railsEnv }) => {
  const isTestMode = railsEnv === 'test' || railsEnv === 'development';
  const t = translations?.recent_earnings || {};

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('vi-VN').format(amount);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
  };

  return (
    <div className="card border rounded-3 mb-4">
      <div className="card-body p-4">
        <h3 className="h6 fw-bold mb-4 pb-3 border-bottom">{t.title}</h3>

        {earnings.length > 0 ? (
          <>
            {earnings.map((earning, index) => (
              <div
                key={earning.id}
                className={`d-flex justify-content-between ${index < earnings.length - 1 ? 'border-bottom pb-3 mb-3' : ''}`}
              >
                <div>
                  <h5 className="fw-semibold mb-1">{formatCurrency(earning.amount)} ₫</h5>
                  <p className="text-muted small mb-1">
                    {earning.referred_user_name} {t.signup}
                  </p>
                  <p className="text-muted" style={{ fontSize: '12px' }}>
                    {formatDate(earning.earned_at)}
                  </p>
                </div>
                <div>
                  {earning.status === 'paid' ? (
                    <span className="badge bg-success bg-opacity-10 text-success">{t.paid}</span>
                  ) : (
                    <span className="badge bg-warning bg-opacity-10 text-warning">{t.pending}</span>
                  )}
                </div>
              </div>
            ))}

            <div className="text-center pt-3 border-top mt-3">
              <a href="#" className="text-decoration-none fw-semibold" style={{ color: '#667eea' }}>
                {t.view_all}
              </a>
            </div>
          </>
        ) : (
          <p className="text-muted text-center mb-0">{t.empty_state}</p>
        )}
      </div>
    </div>
  );
};

export default RecentEarnings;
